import type { TRuleWithTheme } from '@/styles/theme';

export const tagsListContainer: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',

    marginTop: '1rem',
    gap: '0.5rem',
});
